export function loadMFE(mfeBaseUrl: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const scriptsToLoad = ['runtime.js', 'polyfills.js', 'main.js'];
    const scriptsCreatedInThisCall: HTMLScriptElement[] = [];
    let scriptsSuccessfullyLoadedCount = 0;
    let settled = false; 

    const cleanupScripts = () => {
      scriptsCreatedInThisCall.forEach(scriptEl => {
        if (scriptEl.parentNode) {
          scriptEl.parentNode.removeChild(scriptEl);
        }
      });
      scriptsCreatedInThisCall.length = 0;
    };

    const resolvePromise = () => {
      if (settled) return;
      settled = true;
      cleanupScripts();
      resolve();
    };

    const rejectPromise = (error: Error) => {
      if (settled) return;
      settled = true;
      cleanupScripts(); 
      reject(error);
    };

    const onScriptHandled = () => {
      if (settled) return;

      scriptsSuccessfullyLoadedCount++;
      if (scriptsSuccessfullyLoadedCount >= scriptsToLoad.length) {
        resolvePromise();
      }
    };

    const loadSingleScript = (scriptName: string) => {
      if (settled) return;

      const fullSrcPath = `${mfeBaseUrl}/${scriptName}`;

      const existingScript = document.querySelector(`script[src="${fullSrcPath}"]`) as HTMLScriptElement;
      if (existingScript) {
        if (existingScript.parentNode) {
          existingScript.parentNode.removeChild(existingScript);
        }
      }

      const mfeScript = document.createElement('script');
      mfeScript.src = fullSrcPath;
      mfeScript.defer = true; 

      mfeScript.onload = () => {
        onScriptHandled();
      };

      mfeScript.onerror = () => {
        rejectPromise(new Error(`Failed to load script: ${fullSrcPath}`));
      };

      document.body.appendChild(mfeScript);
      scriptsCreatedInThisCall.push(mfeScript); 
    };

    if (scriptsToLoad.length === 0) {
      resolvePromise(); 
      return;
    }

    scriptsToLoad.forEach(scriptName => loadSingleScript(scriptName));
  });
}